import { useEffect } from "react";
import ICONS from "../../../assets/Icons";
import formatCurrency from "../../../utils/CurrencyFormater";
import DataActionField from "../../_utils/TransactionCommonComponents/DataActionField";
import SVGComponent from "../../_utils/SVGComponent";

const RefactorInternalTxnAmount = ({
  refactorTxnData,
  txnPayLoad,
  setTxnPayLoad,
  refactorCopyAmt,
  setRefactorCopyAmt,
  setRefactorPasteAmt,
  refactorPaymentMethod,
  setRefactorPaymentMethod,
  setIsNeft,
  setIsRtgs,
  setAutoFill,
  isRtgs,
  isNeft,
  copyData,
  setCopyData,
}) => {
  const COPY_KEYS = {
    AMOUNT: "TRANSFER_AMOUNT",
  };
  useEffect(() => {
    if (Number(refactorTxnData?.amount) === Number(txnPayLoad?.amount)) {
      setRefactorCopyAmt(true);
    } else {
      setRefactorCopyAmt(false);
    }
  }, [txnPayLoad.amount]);

  useEffect(() => {
    const prevMethod = refactorTxnData?.payment_method?.toUpperCase();
    const currentMethod = txnPayLoad?.settleType?.toUpperCase();

    if (!currentMethod) return;
    setRefactorPaymentMethod(currentMethod === prevMethod);
  }, [txnPayLoad?.settleType]);

  return (
    <main className="flex flex-col lg:flex-row gap-gap-md lg:gap-gap-xl Qsmd:my-margin-md h-screen Qsmd:h-auto bg-primary-bg Qsmd:bg-primary-card w-width-full fixed Qsmd:z-z-index-content z-z-index-overlay Qsmd:relative top-top-base left-left-base mt-margin-base">
      <div className="h-mobile-create-header flex w-width-full bg-primary-nav Qmd:hidden">
        <div className="p-padding-md Qmd:p-padding-base">
          <div
            className="flex flex-shrink-0 cursor-pointer"
            onClick={() => {
              setAutoFill(false);
            }}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-md)"}
              width={"var(--icon-md)"}
              alt="Arrow right"
            />
          </div>
        </div>
        <div className="flex flex-col w-width-full py-padding-sm">
          <div className="text-text-primary text-font-md">
            Create transaction
          </div>
          <p className=" text-text-primary text-xs font-semibold">
            Previous transaction details
          </p>
        </div>
      </div>

      <section className="flex flex-col gap-gap-md lg:flex-1 w-width-full h-auto px-padding-md Qmd:px-padding-base">
        <DataActionField
          label="Transfer Amount"
          value={`INR ${formatCurrency(Number(refactorTxnData?.amount))}`}
          icon={
            refactorCopyAmt ? ICONS?.SELECTED_WITH_GREEN_CIRCLE : ICONS?.COPY
          }
          hoverEnabled={!refactorCopyAmt}
          onClick={() => {
            if (refactorCopyAmt) return;

            const amt = Number(refactorTxnData?.amount);

            setRefactorCopyAmt(true);
            setRefactorPasteAmt(amt);
            setCopyData({
              title: COPY_KEYS.AMOUNT,
              data_type: "numeric",
              value: amt,
            });
          }}
        />
      </section>

      <section className="flex flex-col gap-gap-md lg:flex-1 w-width-full h-auto px-padding-md Qmd:px-padding-base">
        <DataActionField
          label="Select Payment Method"
          value={refactorTxnData?.payment_method?.toUpperCase() ?? ""}
          icon={
            refactorPaymentMethod
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          onClick={() => {
            if (refactorPaymentMethod) return;

            const prevMethod = refactorTxnData?.payment_method?.toUpperCase();

            setIsNeft(prevMethod === "NEFT");
            setIsRtgs(prevMethod === "RTGS");
            setTxnPayLoad((prev) => ({
              ...prev,
              settleType: prevMethod?.toLowerCase(),
            }));
          }}
        />
      </section>
    </main>
  );
};

export default RefactorInternalTxnAmount;
